import React from 'react';

interface IconEyeOpenProps {
    width?: number;
    height?: number;
    color?: string;
}

const IconEyeOpen: React.FC<IconEyeOpenProps> = ({ width = 20, height = 20, color = '#333' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M2.72843 12.7451C2.02015 11.8249 1.66602 11.3648 1.66602 9.9987C1.66602 8.63255 2.02015 8.17247 2.72843 7.25231C4.14265 5.415 6.51444 3.33203 9.99935 3.33203C13.4843 3.33203 15.856 5.415 17.2703 7.25231C17.9785 8.17247 18.3327 8.63255 18.3327 9.9987C18.3327 11.3648 17.9785 11.8249 17.2703 12.7451C15.856 14.5824 13.4843 16.6654 9.99935 16.6654C6.51444 16.6654 4.14265 14.5824 2.72843 12.7451Z"
                stroke={color}
                stroke-width="1.5"
            />
            <path
                d="M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10Z"
                stroke={color}
                stroke-width="1.5"
            />
        </svg>
    );
};

export default IconEyeOpen;
